export function validateBootIdentity() {
    const identity = window.__OS_IDENTITY__;

    // Check 1: Identity object exists
    if (!identity) {
        return { valid: false, code: 'IDENTITY_MISSING' };
    }

    // Check 2: Identity is an object
    if (typeof identity !== 'object') {
        return { valid: false, code: 'IDENTITY_MALFORMED' };
    }

    // Check 3: SHA field exists and is a string
    if (!identity.sha || typeof identity.sha !== 'string') {
        return { valid: false, code: 'IDENTITY_SHA_MISSING' };
    }

    // Check 4: Build timestamp exists
    if (!identity.buildTimestamp) {
        return { valid: false, code: 'IDENTITY_TIMESTAMP_MISSING' };
    }

    return { valid: true };
}

export function renderSystemHalt(errorCode) {
    // If the Boot Gate (HTML level) didn't catch it, we catch it here.
    // We overwrite the root with the same error screen to be consistent.

    // Create halt screen container
    const haltScreen = document.createElement('div');
    haltScreen.id = 'system-halt-screen';
    haltScreen.style.cssText =
        'position:fixed;' +
        'top:0;left:0;right:0;bottom:0;' +
        'background:#000;' +
        'color:#ff0000;' +
        'font-family:monospace;' +
        'padding:40px;' +
        'z-index:999999;' +
        'display:flex;' +
        'flex-direction:column;' +
        'justify-content:center;' +
        'align-items:center;';

    const title = document.createElement('h1');
    title.style.cssText = 'font-size:2em;margin-bottom:20px;';
    title.textContent = '🚫 SYSTEM BOOT HALTED';

    const message = document.createElement('p');
    message.style.cssText = 'font-size:1.1em;margin-bottom:10px;';
    message.textContent = 'The system cannot boot without a valid identity proof.';

    const explanation = document.createElement('p');
    explanation.style.cssText = 'font-size:0.9em;color:#888;margin-bottom:30px;';
    explanation.textContent = 'Application Layer (index.js) blocked mount.';

    const code = document.createElement('p');
    code.style.cssText = 'margin-top:20px;font-size:0.9em;color:#ff6666;border:1px solid #ff0000;padding:10px;';
    code.textContent = 'Error Code: ' + errorCode;

    const authority = document.createElement('p');
    authority.style.cssText = 'margin-top:40px;font-size:0.8em;color:#555;';
    authority.textContent = 'Authority: [index.js] | Law: [PKG-FRONT-BOOT-001]';

    haltScreen.appendChild(title);
    haltScreen.appendChild(message);
    haltScreen.appendChild(explanation);
    haltScreen.appendChild(code);
    haltScreen.appendChild(authority);

    document.body.innerHTML = '';
    document.body.appendChild(haltScreen);
}
